<template>
  <div>
    <el-container>

      <el-main v-loading="loading">
        <el-row>
          <el-col :span="22"
                  :offset="1">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont">&#xe60b;</i>&nbsp;返回首页</el-breadcrumb-item>
              <el-breadcrumb-item>智能报告</el-breadcrumb-item>
              <el-breadcrumb-item>港股</el-breadcrumb-item>
              <el-breadcrumb-item>
                <template v-if="tabsName==='stock'">
                  个股分析
                </template>
                <template v-if="tabsName==='finance'">
                  财务分析
                </template>
                <template v-if="tabsName==='compare'">
                  投资组合
                </template>
                <template v-if="tabsName==='concept'">
                  概念分析
                </template>
                <template v-if="tabsName==='hk'">
                  港股分析
                </template>
                <template v-if="tabsName==='perception'">
                  市场感知
                </template>

              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <br> <br>
          <el-col :span="22"
                  :offset="1"
                  class="whiteContainer">
            <template>
              <el-tabs v-model="tabsName">

                <el-tab-pane label="个股分析"
                             name="stock">
                  <stock v-if="tabsName==='stock'" />
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-col>
        </el-row>
      </el-main>

    </el-container>

  </div>
</template>

<script>

import stock from '../components/index/hk/stock'

export default {
  name: 'ele',
  data: function () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,
      tabsName: 'stock',
      conceptDialogVisible: false,
      conceptSearchLogs: [],
      payDialogVisible: false,
      curReport: {}

    }
  },
  filters: {

  },
  components: {
    stock
  },
  computed: {

  },
  watch: {
    tabsName: function () {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '生成报告页签', this.tabsName])
    }
  },

  methods: {

  },

  mounted () {

  }
}
</script>
<style lang="less" scoped>
.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/hk.vue